import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Text,
  Button,
  useToast,
  Stack,
} from '@chakra-ui/react';
import { HttpContext } from '../../context/HttpContext';
import { useContext, useState, useEffect } from 'react';
import CustomToast from '../../common/CustomToast';
import { MeContext } from '../../context/MeContext';

const DeleteAccountModal = (props) => {
  const { isOpen, onClose, selectedAccount, setParentIsDeleting } = props;
  const { authAxios } = useContext(HttpContext);
  const toast = useToast();
  const { fetchData } = useContext(MeContext);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    if (setParentIsDeleting) {
      setParentIsDeleting(isDeleting);
    }
  }, [isDeleting, setParentIsDeleting]);

  const handleDelete = async () => {
    if (isDeleting) return;

    setIsDeleting(true);
    try {
      await authAxios.delete(`/accounts/${selectedAccount.id}`);

      setTimeout(() => {
        fetchData();

        toast({
          render: (props) => (
            <CustomToast
              status="success"
              title="Account deleted"
              description="Account deleted successfully"
              onClose={props.onClose}
            />
          ),
        });

        onClose();
        setIsDeleting(false);
      }, 500);
    } catch (error) {
      setIsDeleting(false);
      toast({
        render: (props) => (
          <CustomToast
            status="error"
            title="Error deleting account"
            description={
              error.response?.data?.error || 'Error deleting account'
            }
            onClose={props.onClose}
          />
        ),
      });
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={isDeleting ? undefined : onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete Account</ModalHeader>
        {!isDeleting && <ModalCloseButton />}
        <ModalBody>
          <Text>
            Are you sure you want to delete this account?
            <br />
            <strong>{selectedAccount?.email}</strong>
            <br />
            This action cannot be undone.
          </Text>
        </ModalBody>
        <ModalFooter>
          <Stack
            spacing="10px"
            direction={{ base: 'column', sm: 'row' }}
            width={{ base: 'full', sm: 'auto' }}
          >
            <Button
              variant="secondary"
              onClick={onClose}
              isDisabled={isDeleting}
            >
              <Text>Cancel</Text>
            </Button>
            <Button
              onClick={handleDelete}
              isLoading={isDeleting}
              isDisabled={isDeleting}
              colorScheme="red"
            >
              Delete
            </Button>
          </Stack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteAccountModal;
